module.exports = __webpack_public_path__ + "6e608735e7d0689733a87b865f3d2830.svg";